import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'FINANCE_POWER_PAGE';

export const {action: openEditPlanModal, failed: openEditPlanModalFailed} = createAction(
    `${domain}/OPEN_EDIT_PLAN_MODAL`,
    (siteSetId: string, childId: string, childLocalStartDate: string, planId: string) => ({
        siteSetId,
        childId,
        childLocalStartDate,
        planId,
    }),
);

export const {action: openEditPlanModalSuccess} = createAction(
    `${domain}/OPEN_EDIT_PLAN_MODAL_SUCCESS`,
    (siteSetId: string, childId: string, childLocalStartDate: string, planId: string) => ({
        siteSetId,
        childId,
        childLocalStartDate,
        planId,
    }),
);
